// extracted by mini-css-extract-plugin
export default {"container":"loader_container__uKY+y","loader":"loader_loader__pntPB","burger":"loader_burger__dyvar"};